var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.89543 0 0 0.895431 0 2V11.7109C0 12.8155 0.895431 13.7109 2 13.7109H16C17.1046 13.7109 18 12.8155 18 11.7109V7.41048V2C18 0.895431 17.1046 0 16 0H2ZM4.57031 1.75781C5.73342 1.75781 6.67969 2.70408 6.67969 3.86719C6.67969 5.0303 5.73342 5.97656 4.57031 5.97656C3.4072 5.97656 2.46094 5.0303 2.46094 3.86719C2.46094 2.70408 3.4072 1.75781 4.57031 1.75781ZM16.9453 12.6562H1.05469V11.9105L5.44922 7.51595L7.59375 9.66048L13.9219 3.33236L16.9453 6.35579V12.6562Z",
    fill: "#FA0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.b431318a24a05487b748f4352366f3de.svg";
export { ForwardRef as ReactComponent };